module.exports = __webpack_public_path__ + "static/media/ic_left_arrow_24x24.7ba88067.svg";